<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div v-if="currentView === 'depositType'" class="font-normal">
      <div
        class="text-lg md:text-xl still-clean-commit lg:text-2xl text-root-2 -mt-10 mb-6 font-bold flex justify-center"
      >
        Deposit
      </div>
      <div class="flex items-center justify-center">
        <div
          class="my-3 font-bold bg-root-3 md:w-302px mx-2 mt-3 flex px-1 justify-between items-center rounded-full"
        >
          <div
            @click="changeType('fiat')"
            :class="
              type === 'fiat'
                ? 'bg-primary text-white my-1 text-root-4 rounded-full'
                : ''
            "
            class="text-xs md:text-13px rounded-full transition duration-700 ease-in-out cursor-pointer px-2.5 py-3 md:px-6 text-root-1"
          >
            Fiat Currency
          </div>
          <!-- @click="changeType('asset')" -->
          <div
            :class="
              type === 'asset'
                ? 'bg-primary text-white my-1 px-6 text-root-4 rounded-full'
                : 'opacity-40'
            "
            class="text-xs md:text-13px rounded-full transition duration-700 ease-in-out cursor-not-allowed px-2.5 py-3 md:px-6 text-root-1"
          >
            Asset Transfer
          </div>
        </div>
      </div>
      <div
        class="text-13px mt-3 mb-4 font-bold"
        v-if="this.depositForm.currency === 'USDC'"
      >
        <p>
          Exchange Rate: <span>1 USD = {{ exchangeRateBase }} USDC</span>
        </p>
      </div>
      <el-form
        :model="depositForm"
        ref="depositForm"
        size="normal"
        :rules="rules"
      >
        <el-form-item label="Select Currency" prop="currency">
          <el-input readonly class="w-full" v-model="depositForm.currency">
          </el-input>
        </el-form-item>
        <el-form-item class="w-full" label="Enter an Amount" prop="amount">
          <el-input
            prop="amount"
            class=""
            readonly
            name="amount"
            v-model="depositForm.amount"
          >
            <i slot="suffix" class="mr-2">
              {{
                this.type === 'asset'
                  ? 'USDC'
                  : !isLocalCountry
                  ? 'USD'
                  : country.currency
              }}</i
            >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="
            type === 'asset'
              ? 'Network'
              : this.depositForm.currency === 'NGN'
              ? 'Select transfer type'
              : 'Select Transfer Location'
          "
          prop="location"
        >
          <el-radio-group
            class="w-full mt-6"
            v-model="depositForm.location"
            @change="selectLocation"
          >
            <el-radio
              v-for="item in type === 'asset'
                ? usdcNetworks
                : !isLocalCountry
                ? transferLocations
                : transferType"
              :key="item.value"
              :label="item.value"
              :value="item.value"
              :disabled="item.disabled"
              class="mb-6 text-root-4"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-button
          @click="validateForm('depositForm')"
          :loading="isLoading"
          class="mt-4 border-none text-white bg-primary w-full rounded-full py-4"
        >
          Next
        </el-button>
      </el-form>
    </div>
    <div v-if="currentViewAccountInfo">
      <account-information
        @goBack="showTransferType"
        @completedDeposit="toShowPendingDeposit"
        @closeDialog="closeDialog"
        :currentTransaction="transaction"
        @goBackToPendingDialog="goBackToPendingDialog"
        :batchDetails="batchDetails"
      />
    </div>
    <div v-if="currentViewLocalAccountInfo">
      <local-account-information
        @completedDeposit="toShowPendingDeposit"
        @closeDialog="closeDialog"
        :currentTransaction="transaction"
      />
    </div>
    <div>
      <plaid-accounts-dialog
        @depositTypeScreen="depositTypeScreen"
        v-if="currentView === 'plaidAccountsView'"
        @goBack="showTransferType"
        @closeDialog="closeDialog"
      />
    </div>
  </el-dialog>
</template>

<script>
import {
  TRANSFER_LOCATIONS,
  USDC_NETWORKS,
  TRANSFER_TYPE,
  LOCAL_COUNTRIES,
  DEFAULT_TRANSFER_DETAILS
} from '@/utils/constants'
import { ParseMoney } from '@/utils/helpers'
import breakpoints from '@/utils/breakpoints.js'
import pendingDeposit from '@/mixins/pendingDeposit.js'
import localDeposit from '@/mixins/localDeposit.js'
import country from '@/mixins/getCountryDetails.js'
import getBatchDetails from '@/mixins/externalApi.js'
export default {
  name: 'SettleDepositDialog',
  mixins: [pendingDeposit, country, localDeposit, getBatchDetails],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    batchDetails: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      breakpoints,
      transaction: {},
      transferLocations: TRANSFER_LOCATIONS,
      type: 'fiat',
      usdcNetworks: USDC_NETWORKS,
      isLoading: false,
      currencySymbol: '$',
      transferType: TRANSFER_TYPE,
      depositForm: {
        amount: this.batchDetails.amount,
        currency: this.batchDetails.currency,
        location: ''
      },
      rules: {
        location: [
          {
            required: true,
            message: 'Required',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    parseMoney (val) {
      return ParseMoney(val)
    },
    depositUsdc () {
      this.isLoading = true
      const vm = this
      this.getWalletAddresses()
        .then(() => {
          if (!this.walletAddress) {
            this.disabledAccount = true
            vm.$message({
              showClose: true,
              message:
                'Your account is awaiting further verification. Once that is done the disabled payment method would be enabled.',
              type: 'info',
              duration: 6000
            })
            this.isLoading = false
          } else {
            this.$emit('closeDialog')
            this.$emit('showWallet', this.walletAddress)
          }
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
          this.isLoading = false
        })
    },
    proceed () {
      const vm = this
      if (this.type === 'fiat') {
        if (
          this.depositForm.location !== 'Plaid' ||
          this.depositForm.location !== 'Local Currency'
        ) {
          this.$store.dispatch(
            'transactions/wireTransferType',
            this.depositForm.location
          )
        }
        if (this.depositForm.location === 'Plaid') {
          if (this.pendingPlaidDeposit) {
            vm.$message({
              showClose: true,
              message: 'You currently have an ACH transaction in progress',
              type: 'info',
              duration: 5000
            })
          } else {
            this.$store.dispatch(
              'transactions/setDepositTypeView',
              'plaidAccountsView'
            )
            this.$store.dispatch(
              'transactions/setPlaidDepositAmount',
              this.depositForm.amount
            )
          }
        } else {
          this.initiateDepositAmount()
        }
      } else {
        this.processUSDCSettlement()
      }
    },
    depositTypeScreen () {
      this.$store.dispatch('transactions/setDepositTypeView', 'depositType')
    },
    closeShowPlaidWidget () {},
    selectLocation () {},
    goBackToPendingDialog () {},
    async getTransactions () {
      const vm = this
      const payload = {
        number: 1,
        status: '',
        type: '',
        from: '',
        to: ''
      }
      await this.$store
        .dispatch('transactions/getTransactions', payload)
        .then(() => {})
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
    },
    changeType (type) {
      if (this.transaction && Object.keys(this.transaction).length > 0) {
        return
      }
      this.type = type
      if (type === 'fiat') {
        this.depositForm.currency = 'USD'
        this.depositForm.amount = this.batchDetails.amount
      } else if (type === 'asset') {
        this.depositForm.currency = 'USDC'
        this.depositForm.amount =
          this.batchDetails.amount * this.exchangeRateBase
      }
    },
    async initiateDepositAmount () {
      const vm = this
      const info = {
        details: [
          {
            amount: this.depositForm.amount
          }
        ],
        batchDate: [this.routeDetails.id]
      }
      this.isLoading = true
      await this.$store
        .dispatch('transactions/initiateDeposit', info)
        .then(() => {
          this.getTransactions()
          const transaction =
            this.$store.state.transactions.transactions.items[0]
          this.$store.dispatch(
            'transactions/setCurrentTransaction',
            transaction
          )
          this.$store.dispatch(
            'transactions/setDepositTypeView',
            'accountInformation'
          )
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    toShowPendingDeposit () {
      this.$emit('closeDialog')
      this.$emit('completedDeposit')
    },
    validateForm (depositForm) {
      this.$refs[depositForm].validate((valid) => {
        if (valid) {
          this.proceed()
        } else {
          this.$notify.error({
            title: 'Incomplete',
            message: 'please complete details',
            position: 'top-right'
          })
        }
      })
    },
    showTransferType () {
      this.$store.dispatch('transactions/setDepositTypeView', 'depositType')
    },
    async processUSDCSettlement () {
      const vm = this
      await this.$store
        .dispatch('externalApi/settleCustomerDeposit', {
          batchDate: [this.routeDetails.id],
          currency: 'USDC'
        })
        .then(() => this.depositUsdc())
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
    },
    getAllBatchDetails () {
      if (
        this.routeDetails.type === 'withdrawal' ||
        this.routeDetails.type === 'deposit'
      ) {
        this.getTreasuryBatchDetails()
      } else {
        this.getBatchDetails()
      }
    }
  },
  computed: {
    isLocalCountry () {
      const localCountry = LOCAL_COUNTRIES.find(
        (localCountry) => localCountry.currency === this.depositForm.currency
      )
      return !!localCountry
    },
    currentViewAccountInfo () {
      return (
        this.currentView === 'accountInformation' ||
        this.currentView === 'depositDetails' ||
        this.currentView === 'pendingDepositDetails'
      )
    },
    currentViewLocalAccountInfo () {
      return this.currentView === 'localAccountInformation'
    },
    currentTransaction () {
      return this.$store.state.transactions.currentTransaction
    },
    currentView () {
      return this.$store.state.transactions.depositTypeView
    },
    latestTransactions () {
      if (
        !this.$store.state.transactions.transactions ||
        !this.$store.state.transactions.transactions.items
      ) {
        return []
      }
      return this.$store.state.transactions.transactions.items
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '91%'
    },
    routeDetails () {
      return {
        id: this.$route.params.id,
        status: this.$route.query.status,
        currency: this.$route.query.currency
      }
    },
    walletAddress () {
      if (this.$store.state.transactions.walletAddresses.items) {
        const walletId =
          this.$store.state.transactions.walletAddresses.items.find(
            (wallet) => wallet.reason === 'deposit' && wallet.asset === 'USDC'
          )
        if (walletId) {
          return walletId.walletAddress
        }
      }
      return null
    },
    transferInfo () {
      const transferDetails = this.$store.state.auth.transferDetails
      if (transferDetails && Object.keys(transferDetails).length > 0) {
        const details = transferDetails.find(
          (detail) => detail.from === 'USD' && detail.to === 'USDC'
        )
        return details || DEFAULT_TRANSFER_DETAILS
      }
      return []
    },
    exchangeRateBase () {
      return this.transferInfo.exchange_rate
    }
  },
  components: {
    AccountInformation: () =>
      import('@/components/deposit/AccountInformation.vue'),
    LocalAccountInformation: () =>
      import('@/components/deposit/LocalAccountInformation.vue'),
    PlaidAccountsDialog: () =>
      import('@/components/deposit/PlaidAccountsDialog.vue')
  },
  beforeMount () {
    this.transaction = this.currentTransaction
    if (this.batchDetails.currency === 'USDC') {
      this.changeType('asset')
    }
    if (
      this.transaction &&
      Object.keys(this.transaction).length > 0 &&
      this.transactions.status === 'pending'
    ) {
      this.depositForm.currency = 'USD'
      this.depositForm.amount = this.transaction.amount
      // this.transferLocations[2].disabled = true
      // this.transferLocations[1].currency = true
    }
  },
  destroyed () {
    this.$store.dispatch('transactions/setCurrentTransaction', {})
    this.$store.dispatch('transactions/resetLocalDepositInfo', {})
    this.$store.dispatch('transactions/wireTransferType', '')
    this.$store.dispatch('transactions/setDepositTypeView', 'depositType')
  }
}
</script>

<style scoped>
>>> .el-input__inner:focus {
  border-color: #818799;
}
>>> .el-input__inner {
  background-color: var(--background);
  color: var(--text-1);
  height: 50px;
  border: 1px solid var(--text-5);
}
>>> .el-input__inner {
  border-radius: 8px;
  border-color: var(--text-5);
  height: 48px;
}
>>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
>>> .el-form-item {
  margin-bottom: 10px;
}
>>> .el-form-item__label {
  margin-bottom: -8px;
}
>>> .el-button:focus,
>>> .el-button:hover {
  color: white;
  opacity: 0.8;
  border-color: #c7c8d2;
  background-color: var(--color-primary);
}
.small-text {
  font-size: 10px;
}
</style>
